module.exports = __webpack_public_path__ + "static/img/1-5.0cf39b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/1-5.jpg
// module id = 32uD
// module chunks = 1